import { CURRENCY_EXPONENTS } from '@norvix/utils';

/** Reject extra precision; a commission edit must never silently round. */
export function parseCommission(value: string, currency: string): bigint {
  const exponent = CURRENCY_EXPONENTS[currency];
  if (exponent === undefined)
    throw new Error('This currency is not supported for commission editing.');
  const match = /^(\d+)(?:\.(\d*))?$/.exec(value.trim());
  if (!match || (match[2]?.length ?? 0) > exponent)
    throw new Error(`Enter a non-negative amount with at most ${exponent} decimal places.`);
  const amount =
    BigInt(match[1] ?? '0') * 10n ** BigInt(exponent) +
    BigInt((match[2] ?? '').padEnd(exponent, '0') || '0');
  if (amount > 9223372036854775807n)
    throw new Error('The commission exceeds the supported amount.');
  return amount;
}

export function commissionInput(minor: string, currency: string): string {
  const exponent = CURRENCY_EXPONENTS[currency];
  if (exponent === undefined) return '';
  const digits = BigInt(minor)
    .toString()
    .padStart(exponent + 1, '0');
  return exponent ? `${digits.slice(0, -exponent)}.${digits.slice(-exponent)}` : digits;
}
